import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import SelectionListItemStyles from '@vfgroup-oneplatform/foundation/Components/SelectionList/DefaultItem/DefaultItem.styles';
import SelectionList from '@vfgroup-oneplatform/foundation/Components/SelectionList/SelectionList';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../../FrameworkTestKeys';

import styles from './DeviceUpgradeSections.Styles';

const SECTIONS = Object.freeze({
  CAPACITY_TYPE: 'Select capacity',
  COLOR_TYPE: 'Select colour',
});
const mapColorOptions = colorsOptions => {
  const displayedOptions = _map(colorsOptions, (option, index) => {
    const title = option.code;
    const subTitle = option.name;
    return {
      title,
      subTitle,
      testID: FrameworkTestKeys.DeviceColorItem,
    };
  });
  return displayedOptions;
};
const mapCapacityOption = (capacityOptions, selectedCapacityIndex) => {
  const displayedOptions = _map(capacityOptions, (option, index) => {
    const title = option.value;
    const subTitle =
      index === selectedCapacityIndex
        ? 'device_upgrade_device_step_selected'
        : `+${option.priceMonthlyIncrease.value}${option.priceMonthlyIncrease.currency}/${option.priceMonthlyIncrease.period}`;

    return {
      title,
      subTitle,
      testID: FrameworkTestKeys.DeviceCapacityItem,
    };
  });
  return displayedOptions;
};
const DeviceUpgradeSections = ({
  colorsOptions,
  capacityOptions,
  selectedColorIndex,
  selectedCapacityIndex,
  selectOption,
}) => {
  const theme = useTheme();
  const itemStyle = styles.optionStyle(3, 8, theme);
  const CustomItem = ({ index: _index, option, isActive, onPress, ...props }) => (
    <TouchableWithoutFeedback onPress={onPress} {...props}>
      <View style={[itemStyle, SelectionListItemStyles.containerStyle(theme, isActive)]}>
        <View
          style={[
            styles.customOptionColorContainer(isActive),
            {
              backgroundColor: option.title,
            },
          ]}
        />
        <VFText i18nKey={option.subTitle} style={styles.customSubTitleStyle(isActive)} />
      </View>
    </TouchableWithoutFeedback>
  );

  return (
    <View>
      <View style={styles.groupContainer}>
        <VFText style={styles.groupTitle} i18nKey={'device_upgrade_device_step_select_colour'} />
        <SelectionList
          options={mapColorOptions(colorsOptions)}
          initialSelectedIndex={selectedColorIndex}
          onSelectOption={index => {
            selectOption(index, SECTIONS.COLOR_TYPE);
          }}
          itemContainerStyle={itemStyle}
          contentContainerStyle={styles.OptionsContainer}
          activeSubtitleStyle={styles.subTitleStyle(theme)}
          inActiveSubtitleStyle={styles.subTitleStyle(theme)}
          customItem={<CustomItem />}
          withInitialScrollToIndex={true}
          itemWidth={100}
        />
      </View>
      <View style={styles.groupContainer}>
        <VFText style={styles.groupTitle} i18nKey={'device_upgrade_device_step_select_capacity'} />
        <SelectionList
          options={mapCapacityOption(capacityOptions, selectedCapacityIndex)}
          initialSelectedIndex={selectedCapacityIndex}
          onSelectOption={index => {
            selectOption(index, SECTIONS.CAPACITY_TYPE);
          }}
          itemContainerStyle={itemStyle}
          contentContainerStyle={styles.OptionsContainer}
          activeTitleStyle={styles.titleStyle(theme)}
          inActiveTitleStyle={styles.titleStyle(theme)}
          activeSubtitleStyle={styles.subTitleStyle(theme)}
          inActiveSubtitleStyle={styles.subTitleStyle(theme)}
          customItem={null}
          withInitialScrollToIndex={true}
          itemWidth={100}
        />
      </View>
    </View>
  );
};
DeviceUpgradeSections.propTypes = {
  colorsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      deviceImage: PropTypes.shape({ uri: PropTypes.string.isRequired }).isRequired,
    }),
  ),
  capacityOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      priceMonthlyIncrease: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        currency: PropTypes.string.isRequired,
        period: PropTypes.string.isRequired,
      }),
    }),
  ),
  selectedColorIndex: PropTypes.number,
  selectedCapacityIndex: PropTypes.number,
  index: PropTypes.number,
  option: PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
  }),
  isActive: PropTypes.bool,
  selectOption: PropTypes.func,
  onPress: PropTypes.func,
};
export { SECTIONS };
export default DeviceUpgradeSections;
